var exports = {
  "O0": "MenuItemRadio.module__radioButton___Yko5aW",
  "X3": "MenuItemRadio.module__radioButtonSelected___Yko5aW",
  "EC": "MenuItemRadio.module__radioButtonUnselected___Yko5aW",
  "$l": "MenuItemRadio.module__radioIndicator___Yko5aW",
  "aT": "MenuItemRadio.module__labelContent___Yko5aW",
  "Kk": "MenuItemRadio.module__icon___Yko5aW",
  "QK": "MenuItemRadio.module__labelText___Yko5aW",
};

module.exports = exports;
